import $ from 'jquery';
import 'leaflet';
import 'leaflet.awesome-markers';

$(function() {
    let map = $('#map-view');
    if (map.length) {
        let lat = $('meta[name=latitude]').attr('content');
        let long = $('meta[name=longitude]').attr('content');

        if (lat && long) {
            console.log(lat, long);
            map = L.map('map-view').setView([parseFloat(lat), parseFloat(long)], 13);

            L.tileLayer('https://{s}.tile.osm.org/{z}/{x}/{y}.png', {
                attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            }).addTo(map);

            var markerPos = new L.LatLng(lat, long);
            var pinAnchor = new L.Point(10, 11);

            var myIcon = L.AwesomeMarkers.icon(
                {
                    prefix: 'fa fa-home',
                    markerColor: 'blue', // Values = 'red', 'darkred', 'orange', 'green', 'darkgreen', 'blue', 'purple', 'darkpurple', 'cadetblue'
                    className: 'awesome-marker awesome-marker-square',
                    iconAnchor: pinAnchor
                }
            );

            var marker = L.marker(markerPos, {
                icon: myIcon,
                draggable: false,
            }).addTo(map);

        }
    }
});
